import {Svg, Path} from 'react-native-svg';
import {useLingui} from '@lingui/react/macro';
import {useCallback} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {useNavigate} from 'extensions/navigation';
import {useMenu} from 'extensions/viewport/useMenu';
import {Store} from 'store/slices/files/types';
import {selectors} from 'store/slices/files';
import {vectors, colors} from 'config/styles';

import * as effects from 'interface/hooks/effects/files';

export function useMenuFilter(folderKey: string) {
  const {t} = useLingui();
  const sort = useSelector(selectors.getSort);
  const filter = useSelector(selectors.getFilter);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const choose = useCallback((type: Store['filter']['type']) => {
    effects.filter(navigate, dispatch, folderKey)(sort, {type});
  }, [folderKey, navigate, sort, dispatch]);

  const icon = useCallback((target: string) => 
    <Svg viewBox="0 0 24 24" width={16} height={16}>
      <Path
        d={filter.type === target ? vectors.icons.radioOn : vectors.icons.radioOff}
        fill={colors.neutral.mid}
      />
    </Svg>
  , [filter]);

  const {open, exit, reference} = useMenu(
    () => [
      {
        command: 'header',
        text: t`Filter`,
      },
      {
        command: 'all',
        icon: icon('all'),
        text: t`All Items`,
      },
      {
        command: 'public',
        icon: icon('public'),
        text: t`Public`,
      },
      {
        command: 'private',
        icon: icon('private'),
        text: t`Private`,
      },
      {
        command: 'images',
        icon: icon('images'),
        text: t`Images`,
      },
      {
        command: 'video',
        icon: icon('video'),
        text: t`Video`,
      },
      {
        command: 'audio',
        icon: icon('audio'),
        text: t`Audio`,
      },
      {
        command: 'document',
        text: t`Documents`,
        icon: icon('document'),
      },
      {
        command: 'spreadsheet',
        icon: icon('spreadsheet'),
        text: t`Spreadsheets`,
      },
      {
        command: 'presentation',
        icon: icon('presentation'),
        text: t`Presentations`,
      },
      {
        command: 'development',
        icon: icon('development'),
        text: t`Development`,
      },
    ],
    (command: Store['filter']['type']) => {
      choose(command);
      exit();
    },
    false,
  );

  return {open, exit, reference};
}
